import React from 'react';
import Axios from 'axios';
import * as Routes from '@/modules/routes';
import SPADialog from '@/components/admin/SysadminSPA/shared/SPADialog';
import StatesDialogContent, { StateOption } from './StatesDialogContent';

export interface ProgramLicenseRow {
  id: number;
  name: string;
}

interface ProgramLicenseStatesDialogProps {
  programLicense: ProgramLicenseRow | null;
  onClose: () => void;
  onSaved: (programLicenseId: number, selectedLabel: string) => void;
}

// The endpoint renders `root: :data`, which wraps some responses and not others.
const unwrap = (data: any) => (Array.isArray(data) ? data : data?.data ?? []);

const fetchStates = (programLicenseId: number) => Axios
  .get(Routes.plato_api_get_states_program_licenses_path({ program_license_id: programLicenseId }))
  .then(({ data }): StateOption[] => unwrap(data));

const saveStates = (programLicenseId: number, stateIds: number[]) => Axios
  .post(
    Routes.plato_api_program_license_states_path({ program_license_id: programLicenseId }),
    // Rails only sees the key when it is a non-empty value, hence '' for none selected.
    { program_license_states: { states: stateIds.length === 0 ? '' : stateIds } },
  )
  .then(({ data }): string => data?.selected ?? data?.data?.selected ?? '');

const ProgramLicenseStatesDialog = ({
  programLicense,
  onClose,
  onSaved,
}: ProgramLicenseStatesDialogProps) => (
  <SPADialog
    open={!!programLicense}
    onOpenChange={(open) => { if (!open) onClose(); }}
  >
    {programLicense && (
      <StatesDialogContent
        description={programLicense.name}
        fetchStates={() => fetchStates(programLicense.id)}
        saveStates={stateIds => saveStates(programLicense.id, stateIds)}
        title="Edit State-Specific Access"
        onSaved={(label) => {
          onSaved(programLicense.id, label);
          onClose();
        }}
      />
    )}
  </SPADialog>
);

export default ProgramLicenseStatesDialog;
